import dayjs from "dayjs";

export const ChallanDetailsJson = {

    screenTitle: "Challan Details",
    formPath: "/challan-form",


    searchList: [
        {
            label: "From Date",
            controlType: "datepicker",
            placeHolder: "",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            dataKey: "fromDate",
            defaultValue: dayjs(),
            isMandatory: true,
            onSubmit: "compare",
            onSubmitParameter: "toDate-le",
        },
        {
            label: "To Date",
            controlType: "datepicker",
            placeHolder: "",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            defaultValue: dayjs(),
            dataKey: "toDate",
            onSubmit: "compare",
            onSubmitParameter: "fromDate-ge",
            isMandatory: true,
            onSubmit: "compare",
            format: "DD-MM-YYYY",
            maxDatekey: 'fromDate',
            days: 31
        },
    ],
};